import React from 'react';
const TheadTableCentroOperacion = () => {
  return (
    <thead className="bg-gray-800 text-white">
      <tr>
        <th className="px-4 py-3 text-left text-sm font-semibold uppercase">Regional</th>
        <th className="px-4 py-3 text-left text-sm font-semibold uppercase">Código</th>

        <th className="px-4 py-3 text-left text-sm font-semibold uppercase">Municipio</th>
        <th className="px-4 py-3 text-left text-sm font-semibold uppercase">Dirección</th>
        <th className="px-4 py-3 text-left text-sm font-semibold uppercase">Descripción</th>
        <th className="px-4 py-3 text-left text-sm font-semibold uppercase">Estado</th>
        <th className="px-4 py-3 text-left text-sm font-semibold uppercase">{''}</th>
      </tr>
    </thead>
  );
};
export default TheadTableCentroOperacion;
